const currentMenu = () => {
    let menuLink = document.getElementsByClassName('nav__itemsLink');
    for (let i = 0; i < menuLink.length; i++) {
        if (menuLink[i].href === location.href) {
            menuLink[i].classList.add('is-current');
        }
    }
}
currentMenu();